import ScheduleDetails from './ScheduleDetails';

export default ScheduleDetails;



// WEBPACK FOOTER //
// ./src/app/components/TableControls/ScheduleDetails/index.js